import Tabs from '@/components/tabs/Tabs';
import TabsContainer from '@/components/tabs/TabsContainer';
import type { ReactNode } from 'react';

interface TransactionTabsProps {
  panels: ReactNode[];
  routes: string[];
  onChange: (newValue: string) => void;
}

const TransactionTabs = ({ panels, routes, onChange }: TransactionTabsProps) => (
  <TabsContainer>
    <Tabs panels={panels} routes={routes} onChange={onChange} />
  </TabsContainer>
);

export default TransactionTabs;
